import React from 'react'

import styled from 'styled-components'

import TickMark from 'assets/img/icon/tick-mark.png'
import CloseTick from 'assets/img/icon/close2.png'
import { log } from 'utils'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { ImInfo } from 'react-icons/im'

const StyleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  width: -webkit-fill-available;

  div {
    padding-left: 10px;
    font-size: 14px;
    background-image: url(${TickMark});
    background-position: center;
    background-size: contain;
    height: 14px;
    width: 14px;

    &:hover {
      background-image: url(${CloseTick});
    }
  }
`

function RenderFieldCriteriaLI({
  input,
  checked,
  labelName,
  handleChange,
  name,
  itemID,
  t,
}) {
  function _handleClick() {
    const _checked = checked || input?.value
    handleChange({
      checked: !_checked,
      itemID,
    })
  }

  // log(checked , input?.value)

  return (
    <StyleRow name={name || input?.name} onClick={_handleClick}>
      <span>
        {labelName}
        <OverlayTrigger
          placement="right"
          overlay={
            <Tooltip id={`tooltip-right`}>
              {t('algo.tooltip.' + itemID)}
            </Tooltip>
          }
        >
          <ImInfo className="ml-2 fz-12 txt-content" />
        </OverlayTrigger>
      </span>
      {/* <input
        {...input}
        type="checkbox"
        name={name || input?.name}
        id={name || input?.name}
        disabled={disabled}
        checked={checked || input?.value}
        onChange={onChange || input?.onChange}
        itemID={itemID}
      />
      <span className="check_mark" /> */}
      {(checked || input?.value) && <div onClick={_handleClick} />}
    </StyleRow>
  )
}

export default RenderFieldCriteriaLI

// return (
//   <label className={"container-checkbox-filter " + className}>
//     {labelName}
//     <input
//       {...input}
//       type="checkbox"
//       name={name || input?.name}
//       id={name || input?.name}
//       disabled={disabled}
//       checked={checked || input?.value}
//       onChange={onChange || input?.onChange}
//       itemID={itemID}
//     />
//     <span className="check_mark" />
//   </label>
// );
